import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchRoutes, useLocation } from 'react-router-dom';
import history from '@history';
import _ from 'lodash';
import {
  defaultLoginRedirect,
  defaultLogoutRedirect,
  PENDING_URL_KEY,
} from 'src/app/configs/settingsConfig';
import withRouter from '@main/core/withRouter';
import { hasPermission } from './utils/resolver';

function RoutesScope({ onForbidden, ignoreRedirect = false, children }) {
  const { scopes: userScopes } = useSelector((state) => state.profile);
  const { routes } = useSelector((state) => state.routes);
  const { token } = useSelector((state) => state.auth);

  const location = useLocation();
  const { pathname } = location;

  const redirectDefault = useCallback(() => {
    history.replace(token ? defaultLoginRedirect : defaultLogoutRedirect);
  }, [token]);

  useEffect(() => {
    const hasAccess = (path) => {
      // console.log('[RS] Path:', path);
      const matchedRoutes = matchRoutes(routes, path);
      // console.log('[RS] MatchedRoutes:', matchedRoutes);
      const matched = matchedRoutes?.at(-1);
      // console.log('[RS] Matched:', matched);
      const matchedPath = matched?.route?.path;
      // console.log('[RS] MatchedPath:', matchedPath);

      const hasRenderableElement = matchedRoutes?.some((m) => m.route?.element);

      if (matchedPath === '*' || matchedPath === '/' || !hasRenderableElement) return false;
      const isOk = matched && hasPermission([matched], userScopes);
      // console.log('[RS] UserScopes:', userScopes);
      // console.log('[RS] Has permission:', isOk);

      if (!isOk && typeof onForbidden === 'function')
        onForbidden(`No tiene permisos para acceder`, path);
      return isOk;
    };

    if (routes.length === 0) return;

    const dispatchGuards = async () => {
      if (ignoreRedirect === true) sessionStorage.removeItem(PENDING_URL_KEY);

      const storedUrl = sessionStorage.getItem(PENDING_URL_KEY);

      if (_.isString(storedUrl)) {
        sessionStorage.removeItem(PENDING_URL_KEY);

        if (!hasAccess(storedUrl)) {
          redirectDefault();
          return;
        }

        history.replace(storedUrl);
        return;
      }

      if (!hasAccess(pathname)) {
        redirectDefault();
      }
    };

    dispatchGuards();
  }, [onForbidden, pathname, redirectDefault, routes, userScopes]);

  return children;
}

export default withRouter(RoutesScope);
